import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function header() {
    document.addEventListener('DOMContentLoaded', function () {
        gsap.config({ nullTargetWarn: false });

        // change-colorアニメーション
        // window.addEventListener('scroll', function () {
        //     if (window.scrollY > 0) { // スクロールが少しでもある場合
        //         document.querySelector('.js-header').classList.add('change-color');
        //     } else {
        //         document.querySelector('.js-header').classList.remove('change-color');
        //     }
        // });
    });
}
